import {
  resetIndicatorOverlays,
  setActiveTime,
  setDisplayTime,
  setDisplayTimeForActiveIndicator,
  switchIndicators
} from '../actions';

export const updateTimeOrchestrator = (selected_time, display_time = null) => {
  return (dispatch, getState) => {
    if (selected_time !== getState().time.selected_time) {
      dispatch(setActiveTime(selected_time));
      if (display_time) {
        dispatch(setDisplayTime(display_time));
      } else {
        dispatch(setDisplayTimeForActiveIndicator(selected_time));
      }
    }
  };
};

export const updateIndicatorOrchestrator = (indicator) => {
  return (dispatch) => {
    dispatch(switchIndicators(indicator.prefix));
    dispatch(setDisplayTimeForActiveIndicator());
    dispatch(resetIndicatorOverlays());
  };
};



// WEBPACK FOOTER //
// ./src/orchestrators/index.js